
<template>
    <div class="tab_t">
        <ul>
            <li v-for="(item,index) in tabList" :key="index" :class="{li_selected:index==TabSelIndex}" @click="changeTab(index)">{{item[showName]}}</li>
        </ul>
    </div>
</template>
<script>
// import $ from "jquery"
export default {
    props: ["tabList","TabSelIndex","showName"],
    data() {
        return {
            
        }
    },
    mounted() {
    },
    methods: {
        changeTab(index){
            this.$emit('changeTab', index);
        }
    }
}
</script>
<style lang="less" >
    .tab_t{
        margin-bottom: 30px;
        ul{
            display: flex;
            li{
            flex: 1;
            text-align: center;
            font-size: 32px;
            color: #2e6d90;
            }
            li.li_selected{
            font-size: 40px;
            font-weight: 700;
            color:#58effa;
            position: relative;
            }
            .li_selected::after{
            content: "";
            border-top: 2px solid #58effa;
            border-bottom: 1px solid #58effa;
            width: 40px;
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translate(-50%,0);

            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/tab.vue